export const AfsAnonymousIdState = Object.freeze({
    ANONYMOUS_ID_BEGIN: 0,
    ANONYMOUS_ID_CONFIRM_SEEN: 1,
    ANONYMOUS_ID_VERIFY_NOT_SEEN: 2,
    ANONYMOUS_ID_CONFIRM_NOT_SEEN: 3,
    ANONYMOUS_ID_DONE: 4,
    ANONYMOUS_ID_CANCEL: 5,
})